import { FormConfig } from '@domgen/dgx-fe-forms/shared';
import { AppConfig } from '../../models/config/app-config.type';

export const formConfigFactory = (config: AppConfig): FormConfig | undefined =>
  config.form;
